import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const SummaryRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const SummaryHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingX: '4px',
  },
})

const SummaryTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const SummaryLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

const TileGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
    gap: '12px',
  },
})

const Tile = styled(Link, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    overflow: 'hidden',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.12)',
    border: '1.5px solid transparent',
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, transform {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      transform: 'translateY(-2px)',
    },
  },
})

const Thumb = styled('div', {
  base: {
    position: 'relative',
    width: '100%',
    aspectRatio: '16 / 9',
    backgroundColor: '#F1ECFF',
  },
})

const ThumbImage = styled('img', {
  base: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
})

const ThumbFallback = styled('div', {
  base: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '28px',
    color: 'quickpass.primary',
    opacity: '0.7',
  },
})

const TileBody = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    padding: '12px 14px 14px 14px',
  },
})

const TileTitle = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const TilePrice = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.primary',
    margin: '0',
  },
})

const TileMeta = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    margin: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const SkeletonTile = styled('div', {
  base: {
    height: '180px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px solid #F1ECFF',
    opacity: '0.6',
  },
})

const EmptyTile = styled(Link, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '8px',
    padding: '32px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, transform {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      transform: 'translateY(-2px)',
    },
  },
})

const EmptyEmoji = styled('span', {
  base: {
    fontSize: '40px',
    lineHeight: '1',
  },
})

const EmptyTitle = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const EmptyBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    margin: '0',
    maxWidth: '420px',
    lineHeight: '1.5',
  },
})

export {
  SummaryRoot,
  SummaryHeader,
  SummaryTitle,
  SummaryLink,
  TileGrid,
  Tile,
  Thumb,
  ThumbImage,
  ThumbFallback,
  TileBody,
  TileTitle,
  TilePrice,
  TileMeta,
  SkeletonTile,
  EmptyTile,
  EmptyEmoji,
  EmptyTitle,
  EmptyBody,
}
